module.exports = __webpack_public_path__ + "img/reddit.bd017e87.svg";